import { Modes } from '@types'
import is2DMode from '@utils/is2DMode'

export function shouldAxesActivate(isSelected: boolean, mode: Modes): [boolean, boolean, boolean] {
  return isSelected ? [true, !is2DMode(mode), true] : [false, false, false]
}
